import { MenuItem, TextField } from "@mui/material";
import mut from "../hooks/mut";


/**
 * SelectFromList
 * 
 * A component that displays a select of choices. If the choices are an array of strings, the component will be a TextField with a select attribute. If the choices are an array of objects with {_id,name}, the component will be a TextField with a select attribute.
 * 
 * @param {Array} choices the array of choices, either array of string or array of objects with {_id,name}
 * @param {string} value the current value of the component
 * @param {function} setValue a function to call when the value changes
 * @param {string} label the label to display above the component
 * @param {string} style the style to apply to the component
 * @param {string} size the size of the component
 * @param {boolean} none if true, display a "None" option
 * @param {boolean} fullWidth if true, the component will take up all the width available
 * @param {string} url optional, the url to post to when the value changes
 * @param {string} field optional, the field to update when the value changes
 * 
 * @returns a JSX element
 */
export default function SelectFromList(props) {
  const { choices, value, setValue, style, label, size, none, fullWidth, url, field, success } = props

  const change = (val) => {
  
    if (url && field) {
     let res = mut("post",url,{[field]:val})
     if(success) success(res)
    }
    setValue(val)
  }
  
  if(!choices || choices.length===0) return <div></div>  

 const isObjectList = typeof choices[0] === "object";
    
    return (
      <TextField
        size={size}
        label={label}
        style={style}
        value={value}
        select
        onChange={(e) => change(e.target.value)}
        fullWidth={fullWidth}
        {...props}
      >
        {none &&
          <MenuItem
            value=""
            key="none"
          >
            None
          </MenuItem>}
     
        {isObjectList
          ? choices.map((choice) => (
              <MenuItem
                key={choice._id}
                value={choice._id}
              >
                {choice.name}
              </MenuItem>
            ))
          : choices.map((choice, i) => (
              <MenuItem
                key={i}
                value={choice}
              >
                {choice}
              </MenuItem>
            ))}
      </TextField>
    );


    
}